import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

const NoLogsModal = (props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.clearModal}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle>Logs Not Available</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Log extract is not currently available. If the worker recently
          finished, the log extract may still be generating. If the worker
          finished more than 7 days ago, the log extract may have been purged.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          startIcon={<CheckIcon />}
          onClick={props.clearModal}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoLogsModal;
